/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path utils
 * @description Model related utilities
 */
import { t } from "i18next";
import useMeaQuery from "./../apihooks/useMeaQuery";
const translateUnit = (str: string, isRTL: boolean = true) => {
  if (!isRTL) {
    return str;
  }
  let [startPosition, endPosition] = [-1, 0];
  const regex = new RegExp("[0-9,.-]");
  for (let index = 0; index < str.length; index += 1) {
    const char = str.charAt(index);
    if (regex.test(char)) {
      if (startPosition === -1) startPosition = index;
      if (!regex.test(str.charAt(index + 1))) {
        endPosition = index + 1;
        break;
      }
    }
  }
  const numberChunk = str.slice(startPosition, endPosition);
  const numberChunkWithoutComma = numberChunk.replace(",", "");
  const number = parseFloat(numberChunkWithoutComma);
  const preUnit = t(str.slice(0, startPosition).trim());
  const postUnit = t(
    str.slice(startPosition + numberChunk.length, str.length).trim()
  );
  const string = `${preUnit} ${number.toLocaleString()} ${postUnit}`;
  return string;
};
const isMongoId = (id: string): boolean => {
  return /^[a-f0-9]{24}$/i.test(id);
};
const useIdBySymbol = (key?: string, symbol?: string) => {
  return useMeaQuery<
    {
      id: string;
      scorecardid: string;
      topelementid: string;
    }[]
  >(
    String.raw`[SC.${key}].BySymbol(symbol="${symbol}")`,
    String.raw`scorecardid, topelementid`,
    undefined,
    {
      enabled: !!key && !!symbol,
      keepPreviousData: false,
      cacheTime: 10 * 60 * 1000,
      staleTime: 10 * 60 * 1000,
    }
  );
};
export { isMongoId, translateUnit, useIdBySymbol };
